import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Panel from '../../../../UniformComponents/Panel'
import PanelHeader from '../../../../UniformComponents/PanelHeader'
import Button from '../../../../UniformComponents/Button'
import Switch from '../../../../UniformComponents/Switch'
import Select from '../../../form/Select'

@observer
class ReportHeader extends Component {
    render() {
        const { store, reportStore } = this.props
        const { showComparison, showBenchmarking } = reportStore
        const { survey } = store
        const isMaxbiReport = survey.isMaxbi()

        const useNewBenchmarkingModal = process.env.USE_BENCHMARKING_MODAL && store.isExploriAdmin()

        return (
            <Panel cssClass="reportHeader" style={{ overflow: 'unset' }}>
                <PanelHeader>
                    <div style={{ position: 'relative' }}>
                        <span>{survey.title}</span>
                        <div>
                            <div className="expandAll">
                                <Switch
                                    label={i18n.t('report_expand_pages')}
                                    state={Array.from(reportStore.openPages.values()).every((isOpen) => isOpen)}
                                    onToggle={reportStore.toggleAllPages}
                                />
                            </div>
                            <div className="locales">
                                <Select
                                    options={survey.metadata.locales.map((locale) => ({
                                        value: locale,
                                        label: '',
                                        src: `${process.env.CDN_URL}/includes/images/flags/${locale}.png`,
                                    }))}
                                    defaultValue={reportStore.locale}
                                    onBlur={({ value }) => { reportStore.locale = value }}
                                />
                            </div>
                            {!isMaxbiReport
                                ? (
                                    <>
                                        <Button
                                            label={i18n.t('report_comparison')}
                                            icon="fa-light fa-filter-list"
                                            cssClass="regular tertiary"
                                            onClick={() => {
                                                reportStore.showComparison = !showComparison
                                            }}
                                        />
                                        {useNewBenchmarkingModal && (
                                            <Button
                                                label={i18n.t('benchmarkModal.buttonTitle')}
                                                icon="fa-regular fa-retweet"
                                                cssClass="regular tertiary"
                                                onClick={() => {
                                                    reportStore.showBenchmarking = !showBenchmarking
                                                }}
                                            />
                                        )}
                                    </>
                                )
                                : null }
                        </div>
                    </div>
                </PanelHeader>
            </Panel>
        )
    }
}

export default ReportHeader
